<div class="drop-down-header">
  <ng-content></ng-content>
  <ftr-icon
    *ngIf="renderMode == 'drop-down' && showIcon"
    class="drop-down-header__caret"
    icon="ArrowDropDown"
  ></ftr-icon>
</div>
